module.exports = __webpack_public_path__ + "img/en.7f876eb8.svg";